const BREAKPOINT_SM = 576;
const BREAKPOINT_MD = 768;
const BREAKPOINT_LG = 992;
const BREAKPOINT_XL = 1440;
const LANDING_BREAKPOINTS = {
    SM: BREAKPOINT_SM,
    MD: BREAKPOINT_MD,
    LG: BREAKPOINT_LG,
    XL: BREAKPOINT_XL,
};
export { BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL, LANDING_BREAKPOINTS };
